import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Grid, Button, EmailInput, TextCharLimit} from 'views/components';

import {Translate, translate} from 'views/module';

import Backend from 'utils/backend';

const NewUser = (props) => {
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [actionStage, setActionStage] = React.useState('FILL');

  const progressWrap = props.statusProgressWrap;
  const closeModel = props.closeModel;

  const handleSubmit = async (e) => {
    e.preventDefault();
    progressWrap(async () => {
      const input = {
        email,
        firstName,
        lastName,
      };
      await Backend.user.createAdmin(input);
      closeModel(true);
    }, {
      setStage: setActionStage,
      onErrorMessage: (e) => {
        if (e.message === 'email_already_active') {
          return translate('user.UserNew.UserAlreadyExist');
        }
      },
    });
  };

  const isDisabled = () => {
    return !(email && firstName && lastName) || actionStage === 'LOADING';
  };

  return (
    <Dialog onClose={closeModel}>
      <DialogTitle onClose={closeModel}>
        <Translate expression='user.UserNew.Title'/>
      </DialogTitle>
      <DialogContent>
        <form>
          <Grid container spacing={2} style={{padding: 20}}>
            <Grid item sm={6} xs={12}>
              <TextCharLimit
                value={firstName}
                onChange={setFirstName}
                label={translate('user.UserNew.Form.FirstName.Title')}
                charLimit={30}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextCharLimit
                value={lastName}
                onChange={setLastName}
                label={translate('user.UserNew.Form.LastName.Title')}
                charLimit={30}
              />
            </Grid>
            <Grid item xs={12}>
              <EmailInput
                onChange={(e) => e.valid ? setEmail(e.value) : setEmail(null) }
                label={translate('user.UserNew.Form.Email.Title')}
                formFeedback={translate('user.UserNew.Form.Email.FormFeedback')}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={closeModel}>{translate('generic.Cancel')}</Button>
        <Button color="primary" onClick={handleSubmit} disabled={isDisabled()}>{translate('generic.Save')}</Button>
      </DialogActions>
    </Dialog>
  );
};

NewUser.propTypes = {
  closeModel: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NewUser));

